export default __webpack_public_path__ + "static/media/carousel (1).eb98dcc9.jpg";